import { render, staticRenderFns } from "./Tire.vue?vue&type=template&id=1398ff7b"
import script from "./Tire.vue?vue&type=script&lang=js"
export * from "./Tire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports